/**
 * Selects the Candid RPA status body from the active header tab.
 *
 * @module candidRpaBodyRenderer
 */
import CandidRpaChatList from "./candidRpaChatList";
import CandidRpaDocumentPreview from "./candidRpaDocumentPreview";
import {
  CANDID_RPA_NAV_AUTH_LETTER,
  CANDID_RPA_NAV_DOCUMENTS,
  CANDID_RPA_NAV_NOTES,
} from "./candidRpaHeaderNav";
import CandidRpaStatusContent from "./candidRpaStatusContent";

/** Props for {@link CandidRpaBodyRenderer}. */
interface CandidRpaBodyRendererProps {
  /** Active header tab (`notes` | `documents` | `auth-letter`). */
  selectedNavItem: string;
}

/**
 * Renders notes chat, document preview, or auth-letter cards for the tab.
 *
 * @param props.selectedNavItem - Header tab that owns the body
 * @returns Body panel for the selected tab
 */
const CandidRpaBodyRenderer = ({
  selectedNavItem,
}: CandidRpaBodyRendererProps) => {
  if (selectedNavItem === CANDID_RPA_NAV_NOTES) {
    return <CandidRpaChatList />;
  }
  if (selectedNavItem === CANDID_RPA_NAV_DOCUMENTS) {
    return <CandidRpaDocumentPreview />;
  }
  return (
    <CandidRpaStatusContent
      selectedNavItem={selectedNavItem || CANDID_RPA_NAV_AUTH_LETTER}
    />
  );
};

export default CandidRpaBodyRenderer;
